import { useDebounce } from "@website/hooks/debounce";
import { useDomFlightAirportsService } from "@website/ticket-ui/common/services/dom-flight-airport-service";
import {
  AirportsItemType,
  FormattedCity
} from "@website/ticket-ui/common/types";
import { useDomFlightSearchSuggestionsService } from "@website/ticket-ui/dom-flight-search-panel-old/services/use-dom-flight-search-suggestions-service";
import { createOriginDestinationInputText } from "@website/ticket-ui/dom-flight-search-panel-old/utils/createSubtitle";
import { useCallback, useEffect, useMemo, useState } from "react";

export const useDestination = (destination: FormattedCity) => {
  const [destinationQuery, setDestinationQuery] = useState<string>("");
  const [selectedDestinationItem, setSelectedDestinationItem] =
    useState<FormattedCity | null>(null);
  const query = useDebounce(destinationQuery, 250);

  const { data: suggestions } = useDomFlightSearchSuggestionsService();
  const { isLoading, data } = useDomFlightAirportsService(query);

  const onChangeDestinationQuery = useCallback((value: string) => {
    setDestinationQuery(value);
  }, []);

  useEffect(() => {
    if (destination) {
      setSelectedDestinationItem(destination);
    }
  }, [destination]);

  const destinationList = useMemo(
    () => (destinationQuery.length > 1 ? data || [] : suggestions || []),
    [data, suggestions, destinationQuery]
  );

  const selectedDestinationText = useMemo(
    () => createOriginDestinationInputText(selectedDestinationItem),
    [selectedDestinationItem]
  );

  const onSelectDestination = useCallback(
    (id: string) => {
      let destinationItem;
      destinationItem =
        destinationList.find(
          (destination: AirportsItemType) =>
            `${destination.iataCode}-${destination.cityName}` === `${id}`
        ) || null;
      if (!destinationItem) {
        for (const city of destinationList) {
          for (const airport of city.airports) {
            if (
              `${airport.iataCode}-${airport.name}-${city.cityName}` === `${id}`
            ) {
              destinationItem = {
                airportName: airport.name,
                airportFaName: airport.faName,
                airportIataCode: airport.iataCode,
                ...city
              };
            }
          }
        }
      }
      setDestinationQuery("");
      setSelectedDestinationItem(destinationItem);
    },
    [destinationList]
  );

  const onChangeDestination = useCallback((item: FormattedCity | null) => {
    setDestinationQuery("");
    setSelectedDestinationItem(item);
  }, []);

  return {
    selectedDestinationItem,
    selectedDestinationText,
    destinationQuery,
    onChangeDestination,
    onSelectDestination,
    onChangeDestinationQuery,
    destinationList,
    destinationLoading: isLoading,
    destinationLabel: "مقصد",
    destinationIsLoading: isLoading,
    destinationData: data
  };
};
